import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => (
  <div className="flex min-h-screen bg-gray-50">
    <Sidebar />
    <main className="flex-1 ml-64 flex flex-col min-h-screen overflow-x-hidden">
      {children}
    </main>
  </div>
);

export default Layout;
